import { render, staticRenderFns } from "./AppointmentReminderView.vue?vue&type=template&id=82a70018&scoped=true&"
import script from "./AppointmentReminderView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentReminderView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentReminderView.vue?vue&type=style&index=0&id=82a70018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a70018",
  null
  
)

export default component.exports